export default "__VITE_ASSET__ClJbiFfD__"